import { Component, computed, signal, OnInit, OnDestroy, inject } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from './layout/navbar/navbar.component';
import { FooterComponent } from './layout/footer/footer.component';
import { filter } from 'rxjs/operators';
import { AuthService } from './core/services/auth.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-root',
  imports: [CommonModule, RouterOutlet, NavbarComponent, FooterComponent, TranslateModule],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App implements OnInit, OnDestroy {
  private currentUrlSignal = signal<string>('');
  private authService = inject(AuthService);
  private route = inject(ActivatedRoute);
  private translate = inject(TranslateService);
  private titleService = inject(Title);
  private langChangeSub: Subscription | null = null;

  // Проверка: нужно ли показывать navbar
  showNavbar = computed(() => {
    const url = this.currentUrlSignal();
    return !url.startsWith('/admin');
  });

  constructor(private router: Router) {
    // Отслеживаем изменения маршрута
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.currentUrlSignal.set(event.url);
      });

    // Устанавливаем начальный URL
    this.currentUrlSignal.set(this.router.url);
  }

  ngOnInit(): void {
    this.setDocumentTitle();
    this.langChangeSub = this.translate.onLangChange.subscribe(() => this.setDocumentTitle());
    this.checkExistingUserRole();
  }

  ngOnDestroy(): void {
    this.langChangeSub?.unsubscribe();
  }

  private setDocumentTitle(): void {
    const title = this.translate.instant('nav.title');
    this.titleService.setTitle(title);
  }

  /**
   * Проверяет роль для уже авторизованного пользователя при загрузке приложения
   */
  private checkExistingUserRole(): void {
    // Пропускаем если это OAuth callback или страница получения роли
    if (window.location.pathname === '/e-id/callback' || window.location.pathname === '/assign-role') {
      return;
    }
    // Профиль и роли уже загружены в AuthService.bootstrap() (cookie-сессия)
    if (this.authService.isAuthenticated() && this.authService.needsRoleAssignment()) {
      this.router.navigate(['/assign-role']);
    }
  }

}
